// Created by Hieu Manh
import SegmentedControl from "@react-native-segmented-control/segmented-control";
import * as React from "react";
import { useController } from "react-hook-form";
import { StyleSheet } from "react-native";
import { Paragraph, useTheme } from "react-native-paper";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { Block } from "@block";
import { StackSpacing } from "@components/spacing";

interface InputSegmentProps {
  control: any;
  name: string;
  inputProps?: object;
  label: string;
  values: Array<string>;
}

export const InputSegment = (props: InputSegmentProps) => {
  const { control, name, label, values } = props;
  const isDesktop = useDesktopMediaQuery();
  const { colors, fonts } = useTheme();
  const { field } = useController({
    name,
    control,
    defaultValue: "",
  });

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        containerStyle: {
          flex: 1,
        },
        titleForm: {
          ...fonts.semibold,
        },
      }),
    [fonts.semibold],
  );

  const fontStyles = {
    ...fonts.medium,
    color: colors.text,
    fontSize: 13,
  };

  const activeFontStyles = {
    ...fonts.medium,
    color: colors.text,
    fontSize: 13,
  };

  return (
    <Block row={isDesktop ? true : false} spaced ph={spacing.medium}>
      <Block flex={0.5}>
        <Paragraph style={styles.titleForm}>{label}</Paragraph>
      </Block>
      <StackSpacing size={"medium"} />
      <Block flex={1}>
        <SegmentedControl
          style={{ backgroundColor: colors.whiteText, borderRadius: 24 }}
          fontStyle={fontStyles}
          activeFontStyle={activeFontStyles}
          onChange={(event) => {
            field.onChange(event.nativeEvent.selectedSegmentIndex.toString());
          }}
          appearance={"light"}
          values={values}
          selectedIndex={Number(field.value)}
          tintColor={colors.primary}
        />
      </Block>
    </Block>
  );
};
